import { Input } from "components/Form/components/Input/Input";
import { FormComponentProps } from "../FormComponentProps";
import { formatContentEncoding } from "./fileMeta";

/**
 * Read-only display of a FILE's server-detected text encoding (e.g. "utf-8",
 * "windows-1252", "utf-16"). Empty / undetected — the expected value for binary
 * files, undetectable content, and legacy files — renders an em-dash instead of
 * "null". Detection runs for text content-types only; the stored bytes are never
 * re-encoded (files stay binary-identical), the encoding is only recorded and
 * used to decode text for display.
 * (operator-task-file-content-encoding-detection)
 */
export const ContentEncodingFormComponent = ({ input, meta, fieldProps, fieldAttr }: FormComponentProps) => (
    <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
        {formatContentEncoding(input.value)}
    </Input>
);
